export default __webpack_public_path__ + "static/media/18.04a7cd14.png";